<zip-button
  data-test-id="contentSkipButton"
  [config]="buttonConfig"
  (zipButtonClicked)="targetFocus()"
></zip-button>
